import { jsx as _jsx } from "react/jsx-runtime";
const VARIANTS = {
    primary: {
        primary: 'text-green-600 bg-transparent outline-green before:bg-green hover:outline-green group-hover:outline-green hover:text-white group-hover:text-white',
        inverse: 'text-green-600 bg-transparent outline-green before:bg-green hover:outline-green group-hover:outline-green hover:text-white group-hover:text-white'
    },
    secondary: {
        primary: 'text-white bg-gold-600 outline-gold-600 before:bg-grey-100 hover:outline-grey-100 group-hover:outline-grey-100 hover:text-grey-400 group-hover:text-grey-400',
        inverse: 'text-grey-400 outline-grey-100 bg-grey-100 before:bg-gold-600 hover:outline-gold-600 group-hover:outline-gold-600 hover:text-white group-hover:text-white'
    },
    grey: {
        primary: 'text-grey-400 outline-grey-100 bg-grey-100 before:bg-gold-600 hover:outline-gold-600 group-hover:outline-gold-600 hover:text-white group-hover:text-white',
        inverse: 'text-white bg-gold-600 outline-gold-600 before:bg-grey-100 hover:outline-grey-100 group-hover:outline-grey-100 hover:text-grey-400 group-hover:text-grey-400',
    },
    text: {
        primary: 'text-green-600 hover:text-green-700 focus:text-green-700',
        inverse: 'text-green-600 hover:text-green-700 focus:text-green-700',
    },
    'no-underline': {
        primary: 'text-green-600 hover:text-green-700 focus:text-green-700',
        inverse: 'text-green-600 hover:text-green-700 focus:text-green-700',
    },
};
const variantToClasses = (variant, invert) => {
    const colors = VARIANTS[variant];
    const classes = [];
    if (invert)
        classes.push(colors.inverse);
    else
        classes.push(colors.primary);
    return classes;
};
const ButtonLink = ({ variant = 'primary', href, target = '_self', isDisabled = false, invert = false, children }) => {
    const classes = [];
    if (variant === 'text' || variant === 'no-underline') {
        classes.push('text-link');
    }
    else {
        classes.push('button');
    }
    if (variant === 'no-underline')
        classes.push('no-underline');
    if (variant)
        classes.push(...variantToClasses(variant, invert));
    if (isDisabled)
        classes.push('is-disabled');
    return (_jsx("a", { href: href, target: target, className: classes.join(' '), children: _jsx("span", { className: "relative", children: children }) }));
};
export default ButtonLink;
